import { Text } from '@chakra-ui/react';
import { Helmet } from 'react-helmet';

import SectionStartTemplate from '../../../templates/sectionStart';
import { SectionStatus } from '../../../atoms/section-summary';
import { titleAppend } from '../../../../utilities/head';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from '../../../../store';
import {
  createNavigateForwardAction,
  createNavigateBackwardAction,
  createNavigateToAction
} from '../../../../middleware/actions';
import { toggleTaskMenu } from '../../../../store/ui/actions';
import * as types from 'types';

const ConsentsSectionStart = () => {
  const historySectionStatus = useSelector((state: ApplicationState) => state.config.historySectionStatus);
  const historyInactive = historySectionStatus === types.SectionStatusType.INACTIVE;

  const financeSectionStatus = useSelector((state: ApplicationState) => state.config.financeSectionStatus);
  const financeInactive = financeSectionStatus === types.SectionStatusType.INACTIVE;

  const personalStarted = useSelector((state: ApplicationState) => state.student.offer.isPISectionStarted);
  const historyStarted = useSelector((state: ApplicationState) => state.student.offer.isHSectionStarted);
  const financeStarted = useSelector((state: ApplicationState) => state.student.financials.isSectionStarted);

  const personalComplete = useSelector((state: ApplicationState) => state.student.offer.isPISectionComplete);
  const historyComplete = useSelector((state: ApplicationState) => state.student.offer.isHSectionComplete);
  const financeComplete = useSelector((state: ApplicationState) => state.student.financials.isSectionComplete);
  const warning = useSelector((state: ApplicationState) => state.config.Checklist.Consents.SectionStart.warning);

  const personalInfoStatus = (() => {
    if (personalComplete) {
      return SectionStatus.complete;
    } else if (personalStarted) {
      return SectionStatus.incomplete;
    } else {
      return SectionStatus.empty;
    }
  })();

  const historyStatus = (() => {
    if (historyInactive) {
      return SectionStatus.skipped;
    } else if (historyComplete) {
      return SectionStatus.complete;
    } else if (historyStarted) {
      return SectionStatus.incomplete;
    } else {
      return SectionStatus.empty;
    }
  })();

  const financeStatus = (() => {
    if (financeInactive) {
      return SectionStatus.skipped;
    } else if (financeComplete) {
      return SectionStatus.complete;
    } else if (financeStarted) {
      return SectionStatus.incomplete;
    } else {
      return SectionStatus.empty;
    }
  })();

  const dispatch = useDispatch();
  const onPrevious = () => dispatch(createNavigateBackwardAction());
  const onNext = () => dispatch(createNavigateForwardAction());
  const onBackToTaskList = () => {
    dispatch(createNavigateToAction('/dashboard'));
    dispatch(toggleTaskMenu(false));
  };

  const pageTitle = 'Section 3 - Your Responsibilities';

  return (
    <SectionStartTemplate
      pageHeader={pageTitle}
      minsToComplete={5}
      section1={personalInfoStatus}
      section2={historyStatus}
      section3={SectionStatus.todo}
      section4={financeStatus}
      onNext={onNext}
      onPrevious={onPrevious}
      onBackToTaskList={onBackToTaskList}
    >
      <Helmet>
        <title>
          {pageTitle} {titleAppend}
        </title>
      </Helmet>

      <Text fontSize="lg" dangerouslySetInnerHTML={{ __html: warning }} />
    </SectionStartTemplate>
  );
};

export default ConsentsSectionStart;
